import { render } from "./Center.vue?vue&type=template&id=83762cb4"
import script from "./Center.vue?vue&type=script&lang=js"
export * from "./Center.vue?vue&type=script&lang=js"
script.render = render

export default script